// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_CHAT_URL: 'https://dev-chat-api.optistech.com/',
  // API_URL: 'https://ae-online-api.myoptistech.com/api/v1/',
  // API_URL_V2 : 'https://ae-online-api.myoptistech.com/api/v2/',
  // API_URL: 'http://192.168.1.147:30033/api/v1/',
  // API_URL_V2: 'http://192.168.1.147:30033/api/v2/',
  // API_URL_V3: 'http://192.168.1.147:30033/api/v3/',

  API_URL: 'https://ae-online-api-dev.intechdevkh.com/api/v1/',
  API_URL_V2 : 'https://ae-online-api-dev.intechdevkh.com/api/v2/',
  API_URL_V3: 'https://ae-online-api-dev.intechdevkh.com/api/v3/',
  RECAPTCHA_SITE_KEY: '6LdxCFkcAAAAAC1UGVSvHbPrB0FvWTp2gbPWoLlC',
  RECAPTCHA_SITEKEY: "0x4AAAAAACBh6Q23Rn_Y5ZeA",
  ANDROID_APP: '',
  IOS_APP: '',
  GOOGLE_CLIENT_ID: "935324356950-drirlhr4n1rdqbmnh8eupa2nkrpl94hf.apps.googleusercontent.com",//'541213759334-2fopism4u4u1ok3uab54sklj07bf0gf7.apps.googleusercontent.com',
  FACEBOOK_CLIENT_ID: '185217107024571', //'646078861022764', //'771636531232654',
  checkout_popup_css: "",
  checkout_popup_jquery: "https://ajax.googleapis.com/ajax/libs/jquery/2.2.4/jquery.min.js",
  checkout_popup_js: "https://checkout.payway.com.kh/plugins/checkout2-0.js",
  limit_tickets: 5,
  term_condition_url: "/tessdsafdat",
  env_name: "development",
  APPLE_SERVICE_ID: 'com.intechdevkh.ae-online-sale-dev',
  APPLE_REDIRECT_URI: 'https://ae-online-sale-dev.intechdevkh.com/auth/login',
  API_AE_ADMIN_URL: 'https://www.angkorenterprise.gov.kh/api/admin',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
